
export const planets = [
    {
        id: 0,
        name: 'Mercury',
        path: '/mercury',
        color: 'hsl(196, 83%, 93%)',
        sectionColor: 'hsl(194, 48%, 49%)',
        info: 'Stay updated with the latest news and warnings.'
    },
    {
        id: 1,
        name: 'Venus',
        path: '/venus',
        color: 'hsl(39, 88%, 73%)',
        sectionColor: 'hsl(33, 82%, 61%)',
        info: 'Get health tips and resources to stay healthy.'
    },
    {
        id: 2,
        name: 'Earth',
        path: '/earth',
        color: 'hsl(238, 99%, 66%)',
        sectionColor: 'hsl(263, 67%, 51%)',
        info: 'Learn about the alien species spotted on Hacunia.'
    },
    {
        id: 3,
        name: 'Mars',
        path: '/mars',
        color: 'hsl(12, 100%, 64%)',
        sectionColor: 'hsl(10, 63%, 51%)',
        info: 'View the locations where aliens have been spotted.'
    },
    {
        id: 4,
        name: 'Jupiter',
        path: '/jupiter',
        color: 'hsl(27, 75%, 70%)',
        sectionColor: 'hsl(2, 68%, 53%)',
        info: 'Chat with fellow citizens about alien threats.'
    },
    {
        id: 5,
        name: 'Saturn',
        path: '/saturn',
        color: 'hsl(40, 96%, 70%)',
        sectionColor: 'hsl(17, 73%, 46%)',
        info: 'Chat with our AI survival bot to learn escape strategies.'
    },
    {
        id: 6,
        name: 'Uranus',
        path: '/uranus',
        color: 'hsl(168, 82%, 67%)',
        sectionColor: 'hsl(169, 73%, 44%)',
        info: 'Educational resources for crisis management.'
    },
    {
        id: 7,
        name: 'Neptune',
        path: '/neptune',
        color: 'hsl(222, 95%, 63%)',
        sectionColor: 'hsl(222, 87%, 56%)',
        info: 'We value your feedback!'
    },
];
